import { Field } from 'formik';
import { ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import variaveis from '../../styles/variaveis.scss';

export const FooterStyle = styled(ModalFooter)`
	&& {
		border-top: 0;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		padding-left: 0;
		padding-right: 0;
	}
	label {
		font-style: italic
		margin: 0
	}
`;

export const TextareaStyle = styled(Field)`
	&& {
		width: 100%;
	}
`;

export const RequiredField = styled.span`
	color: ${variaveis.red};
`;
